import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_soap_12: FaireProductEntity = {
  token: "nyc-soap-12",
  type: "product",
  name: "DUMBO Beard Oil",
  brandName: "Brooklyn Grooming",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/b3503ac0d6e409146515fd732ade635576645ea9ce25f9e3162a5e8b7af7f2fb.webp",
  priceDollars: 24,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/b3503ac0d6e409146515fd732ade635576645ea9ce25f9e3162a5e8b7af7f2fb.webp",
  weight: 0.3,
  dimensions: {
    width: 2,
    height: 5,
    depth: 2,
  },
  description: "Premium beard oil from DUMBO",
  categoryTokens: ["cat_bath-all"],
  tags: ["nyc-local", "premium", "organic", "brooklyn"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
